module.exports = __webpack_public_path__ + "static/calloutSocial-78fc4334a6001bcda8a5ae68bccb3b56.jpg";